import http from "utils/httpRequest/http";

export const uploadStoreImage = (storeId = "", image = null, type = "") => {
  const formData = new FormData();
  formData.append(type, image);
  return http.post(`/sellerDetail/${storeId}`, formData);
};
